<template>
  <div>
    <!-- Modal -->
    <div v-if="importingsurvey" class="modal fade show d-block" tabindex="-1" style="background-color: rgba(0,0,0,0.5);">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Importing Survey</h5>
          </div>
          <div class="modal-body">
            <div class="text-center">
              <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
              <p class="mt-3">Importing survey {{ importingsurvey }}...</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <div v-show="consultant_id==0">
      <div class="row col-12">
        <div class="input-group col-9">
          <input
            class="form-control"
            v-model="search"
            placeholder="Search name or e-mail"
            type="text"
            @input="consultants_filter"
            autocomplete="off"
          />
          <button class="btn btn-outline-secondary" type="button" @click="search = ''">
            X
          </button>
        </div>
      </div>
      
      <div class="table-responsive mt-3">
        <table class="table table-hover" id="consultants">
          <thead>
            <tr>
              <th>Select</th>
              <th>ID</th>
              <th>Name</th>
              <th>Email</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody v-if="loading">
            <tr>
              <td colspan="6" class="text-center text-danger my-2">
                <div class="spinner-border text-primary align-middle" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr 
              v-for="(item, index) in consultants" 
              :key="item.id"
              @click="legacyconsultant_get(item)"
              style="cursor: pointer;"
            >
              <td>
                <div class="py-1">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    :id="'selected' + index"
                    v-model="item.selected"
                    @change="countselected"
                    @click.stop
                  />
                </div>
              </td>
              <td>{{ item.id }}</td>
              <td>
                <div :class="`py-1 ${anon ? 'g-anon' : '' }`">
                  {{ item.consultant_name }}
                </div>
              </td>
              <td>
                <div :class="`py-1 ${anon ? 'g-anon' : '' }`">
                  {{ item.email }}
                </div>
              </td>
              <td>{{ item.status }}</td>
              <td>
                <span 
                  v-if="item.new_user_id==0"
                  @click.prevent.stop="legacyconsultant_import(item)"
                  style="cursor: pointer;"
                >
                  <fa-icon name="file-import" />
                </span>
                <span v-if="item.new_user_id!=0">
                  <fa-icon name="eye" />
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    
    <div v-show="consultant_id!=0">
      <div class="d-flex align-items-center mb-3">
        <button class="btn btn-outline-primary" @click.prevent="consultant_id=0">&lt; Return to list</button>
        <h3 class="mb-0 ms-4">Surveys for <span :class="`py-1 ${anon ? 'g-anon' : '' }`">{{ consultant.consultant_name }}</span></h3>
      </div>
      
      <div class="table-responsive">
        <table class="table table-hover" id="consultantsurveys">
          <thead>
            <tr>
              <th v-for="field in surveyfields" :key="field.key">{{ field.label }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in consultant.surveys" :key="item.id">
              <td></td>
              <td>{{ item.id }}</td>
              <td>{{ item.group_test_name }}</td>
              <td>{{ item.group_test_start }}</td>
              <td>{{ item.group_test_end }}</td>
              <td>
                <span 
                  class="px-4"
                  @click.prevent="legacysurvey_import(item)"
                  style="cursor: pointer;"
                >
                  <fa-icon name="file-import" />
                </span>
                <span v-if="item.imported!=0">
                  <fa-icon name="check" />
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import _ from "lodash";

const surveyfields = [
  { key: "select", label: "", sortable: false },
  { key: "id", label: "ID", sortable: true },
  { key: "group_test_name", label: "Survey Name", sortable: true },
  { key: "group_test_start", label: "Start Date", sortable: true },
  { key: "group_test_end", label: "End Date", sortable: false },
  { key: "actions", label: "", sortable: false },
];
export default {
  data: function () {
    return {
      search: "",
      searching: false,
      searchcalc: false,
      consultant_id: 0,
      consultant: {},
      consultants: [],
      surveyfields: surveyfields,
      importingsurvey: false,
      loading: false,
    }
  },
  computed: {
    anon: function() {
        return this.$store.state.anon;
    },
  },
  mounted() {
    this.consultants_get();
  },
  methods: {
    countselected() {
      // Placeholder for count selected logic
    },
    legacysurvey_import(item) {
      this.$store.dispatch('legacysurvey_import', { 
        id: item.id, 
        old_consultant_id: this.consultant_id, 
        new_consultant_id: this.consultant.new_user_id 
      })
      .then(() => {
        this.importingsurvey = item.id;
        this.legacyconsultant_get({ id: this.consultant_id });
        setTimeout(() => {
          this.importingsurvey = false;
        }, 2000);
      })
    },
    legacyconsultant_import(item) {
      this.$store.dispatch('legacyconsultant_import', { id: item.id })
      .then(() => {
        this.consultants_get();
      })
    },
    legacyconsultant_get(item) {
      const legacyconsultant_id = item.id;
      this.$store.dispatch('legacyconsultant_get', { id: legacyconsultant_id })
      .then((resp) => {
        this.consultant = resp.data.result[0];
        this.consultant_id = item.id;
      })
    },
    consultants_filter: _.debounce(function () {
      this.searchcalc = true;
      setTimeout(
        function () {
          this.consultants_filterget();
          this.searchcalc = false;
          this.searching = false;
        }.bind(this),
        500
      );
    }, 300),
    consultants_filterget() {
      this.currentPage = 1;
      this.consultants_get();
    },
    consultants_get() {
      this.loading = true;
      var filter = "";
      if (this.search != "") {
        filter = {
          consultant_email: {
            operator: "LIKE",
            value: this.search,
          },
        };
      }
      this.$store.dispatch("legacyconsultant_search", {
          filter: filter,
        })
        .then((resp) => {
          this.consultants = [];
          for (var i = 0; i < resp.data.result.length; i++) {
            var result = {
              id: resp.data.result[i].id,
              consultant_name: resp.data.result[i].consultant_name,
              email: resp.data.result[i].email,
              surveys: resp.data.result[i].surveys,
              new_user_id: resp.data.result[i].new_user_id,
              status: resp.data.result[i].new_user_id != 0 ? 'Imported as ID '+resp.data.result[i].new_user_id: 'Not imported',
              actions: '',
              selected: false,
            };
            this.consultants.push(result);
          }
          this.rows = resp.data.total;
          this.loading = false;
        });
    },
  }
}
</script>
<style scoped>

</style>
